
<template>
    <div>


        <h2> {{__('messages.know_destinations')}} {{country.name}}</h2>


        <CountryDestinationGroup :groups="groups" />

    </div>
</template>







<script>
    import { CountryDestinationServices } from '../../services/CountryDestinationService';
    import CountryDestinationGroup from '../components/CountryDestinationGroup.vue';

    const groups = __pt.groups;

    export default {
        props: {
            msg: String,
        },
        data() {
            return {
                name: "Nombre",
                groupedState: CountryDestinationServices.GetContent(),
                groups: groups,
                country: {}

            };
        },
        async mounted() {
            this.country = this.groupedState.response.countries[0];
        },

        components: {
            CountryDestinationGroup
        }
    };
</script>
